/* RNG Booster Toolkit — conversion features layered on the Ride theme. */
(() => {
  const cfgEl = document.getElementById('rng-config');
  if (!cfgEl) return;
  let C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[rng] bad config', e); return; }

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
  const store = {
    get(k, session) { try { return (session ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } },
    set(k, v, session) { try { (session ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} },
  };
  const hasPubSub = () => typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';

  /* ---------- money ---------- */
  function money(cents) {
    const n = Number(cents || 0) / 100;
    const group = (str, sep) => str.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const fmt = C.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      const [i, d] = n.toFixed(2).split('.');
      switch (key) {
        case 'amount_no_decimals': return group(String(Math.round(n)), ',');
        case 'amount_with_comma_separator': return group(i, '.') + ',' + d;
        case 'amount_no_decimals_with_comma_separator': return group(String(Math.round(n)), '.');
        case 'amount_with_apostrophe_separator': return group(i, "'") + '.' + d;
        default: return group(i, ',') + '.' + d;
      }
    });
  }

  /* ---------- fetch hook: refresh cart UI on any cart change ---------- */
  const origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = origFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then((res) => {
        if (!res.ok) return;
        refreshCart();
        if (C.atc === 'checkout' && /\/cart\/add/.test(url)) window.location.href = root + 'checkout';
      }).catch(() => {});
    }
    return p;
  };

  /* ---------- recommendations ---------- */
  const recCache = new Map();
  function recs(pid, limit) {
    const key = pid + ':' + limit;
    if (!recCache.has(key)) {
      recCache.set(key, (async () => {
        for (const intent of ['complementary', 'related']) {
          try {
            const r = await origFetch(`${root}recommendations/products.json?product_id=${pid}&limit=${limit}&intent=${intent}`);
            if (!r.ok) continue;
            const j = await r.json();
            if (j.products && j.products.length) return j.products;
          } catch (e) {}
        }
        return [];
      })());
    }
    return recCache.get(key);
  }
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');

  /* ---------- add to cart (keeps theme drawer / popup in sync) ---------- */
  async function addItems(items) {
    const cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items };
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      body.sections = cartEl.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    const res = await origFetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
    if (C.atc === 'checkout') { window.location.href = root + 'checkout'; return data; }
    const first = (data.items && data.items[0]) || {};
    if (cartEl && data.sections && typeof cartEl.renderContents === 'function') {
      try {
        if (cartEl.tagName === 'CART-DRAWER') cartEl.classList.remove('is-empty');
        cartEl.renderContents(Object.assign({}, data, { id: first.id, key: first.key }));
      } catch (e) {}
    }
    if (hasPubSub()) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rng-booster', productVariantId: first.id, cartData: data });
    else if (/\/cart$/.test(window.location.pathname)) window.location.reload();
    refreshCart();
    return data;
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-rng-add]');
    if (!btn) return;
    e.preventDefault();
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    try { await addItems([{ id: Number(btn.dataset.rngAdd), quantity: 1 }]); btn.textContent = '✓'; }
    catch (err) { btn.textContent = label; alert(err.message); }
    setTimeout(() => { btn.disabled = false; btn.textContent = label; }, 1500);
  });

  /* ---------- cart: shipping note + recommendations ---------- */
  const state = { cart: null, ver: 0, upsellHTML: '' };

  const truck = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path fill="currentColor" d="M3 6h11v9h1.2a3 3 0 0 1 5.6 0H21v-4l-2.5-3H16V6H3Zm0 11a2 2 0 0 0 4 0Zm13 0a2 2 0 0 0 4 0Z"/></svg>';
  const shipHTML = () => `${truck}<span>${esc(C.ship.text)}</span>`;

  async function buildUpsell(cart) {
    if (!C.upsell.enabled || !cart.item_count) return '';
    const inCart = new Set(cart.items.map((i) => i.product_id));
    const list = (await recs(cart.items[0].product_id, 8))
      .filter((p) => !inCart.has(p.id) && p.variants.some((v) => v.available))
      .slice(0, 4);
    if (!list.length) return '';
    return `<p class="rng-up__heading">${esc(C.upsell.heading)}</p><div class="rng-up__list">${list.map((p) => {
      const v = p.variants.find((x) => x.available);
      const img = p.featured_image ? `<img src="${esc(sized(p.featured_image, 160))}" alt="" width="64" height="64" loading="lazy">` : '';
      return `<div class="rng-up__item"><a class="rng-up__img" href="${esc(p.url)}">${img}</a><div class="rng-up__info"><a class="rng-up__title" href="${esc(p.url)}">${esc(p.title)}</a><span class="rng-up__price">${money(v.price)}</span></div><button type="button" class="rng-up__add" data-rng-add="${v.id}">${esc(C.upsell.button)}</button></div>`;
    }).join('')}</div>`;
  }

  function slot(selector, pos, cls) {
    const anchor = $(selector);
    if (!anchor || !anchor.parentElement) return null;
    let el = anchor.parentElement.querySelector(':scope > .' + cls);
    if (!el) { el = document.createElement('div'); el.className = cls; anchor.insertAdjacentElement(pos, el); }
    return el;
  }

  function renderCartUI() {
    if (!state.cart) return;
    if (C.ship.enabled && C.ship.text) {
      [['#CartDrawer .drawer__header', 'afterend'], ['#cart-notification .cart-notification__links', 'beforebegin'], ['#main-cart-footer .cart__blocks', 'beforebegin']]
        .forEach(([s, p]) => {
          const el = slot(s, p, 'rng-ship');
          if (el && !el.dataset.done) { el.innerHTML = shipHTML(); el.dataset.done = '1'; }
        });
    }
    if (C.upsell.enabled) {
      [['#CartDrawer .drawer__footer', 'beforebegin'], ['#cart-notification .cart-notification__links', 'beforebegin'], ['#main-cart-footer', 'beforebegin']]
        .forEach(([s, p]) => {
          const el = slot(s, p, 'rng-up');
          if (el && el.dataset.v !== String(state.ver)) { el.innerHTML = state.upsellHTML; el.hidden = !state.upsellHTML; el.dataset.v = state.ver; }
        });
    }
  }

  let refreshT;
  function refreshCart() {
    clearTimeout(refreshT);
    refreshT = setTimeout(async () => {
      try { state.cart = await (await origFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json(); }
      catch (e) { return; }
      try { state.upsellHTML = await buildUpsell(state.cart); } catch (e) { state.upsellHTML = ''; }
      state.ver++;
      renderCartUI();
    }, 120);
  }

  /* ---------- product helpers ---------- */
  const P = C.product;
  function currentVariant() {
    if (!P) return null;
    const inp = $('product-info form[action*="/cart/add"] [name="id"]') || $('form[id^="product-form-template"] [name="id"]') || $('form[action*="/cart/add"] [name="id"]');
    const id = inp ? Number(inp.value) : 0;
    return P.variants.find((v) => v.id === id) || P.variants[0] || null;
  }
  const variantFns = [];
  let lastVid = null;
  function checkVariant() {
    const v = currentVariant();
    if (!v || v.id === lastVid) return;
    lastVid = v.id;
    variantFns.forEach((f) => { try { f(v); } catch (e) {} });
  }
  const onVariant = (fn) => variantFns.push(fn);

  /* ---------- timers ---------- */
  const timers = [];
  setInterval(() => { const now = Date.now() / 1000; timers.slice().forEach((t) => t(now)); }, 1000);
  function mountTimer(box, end, onEnd) {
    box.classList.add('rng-timer');
    box.innerHTML = ['d', 'h', 'm', 's'].map((u) => `<span class="rng-timer__unit"><b data-u="${u}">00</b><small>${esc(C.labels[u])}</small></span>`).join('');
    const set = (now) => {
      const left = Math.max(0, Math.floor(end - now));
      const t = { d: Math.floor(left / 86400), h: Math.floor((left % 86400) / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
      box.querySelectorAll('[data-u]').forEach((b) => { b.textContent = String(t[b.dataset.u]).padStart(2, '0'); });
      if (left <= 0) { const i = timers.indexOf(set); if (i > -1) timers.splice(i, 1); if (onEnd) onEnd(); }
    };
    timers.push(set);
    set(Date.now() / 1000);
  }

  function initCountdownSections() {
    $$('[data-rng-countdown]').forEach((el) => {
      const end = Number(el.dataset.end || 0);
      const box = el.querySelector('[data-rng-timer]');
      const ended = () => {
        if (el.dataset.expired === 'hide') { const sec = el.closest('.shopify-section'); if (sec && !(window.Shopify && Shopify.designMode)) sec.hidden = true; }
        const msg = el.querySelector('[data-rng-expired]');
        if (msg) msg.hidden = false;
        if (box) box.hidden = true;
      };
      if (!end || !box) return;
      if (end <= Date.now() / 1000) return ended();
      mountTimer(box, end, ended);
    });
  }

  /* ---------- product notices: pre-order, limit, countdown ---------- */
  state.preorder = false;
  const tagsOf = (el) => (el.dataset.tags || '').split(',').map((t) => t.trim()).filter(Boolean);

  function initNotices() {
    $$('[data-rng-notices]').forEach((el) => {
      const tags = tagsOf(el);
      const now = Date.now() / 1000;
      const release = Number(el.dataset.release || 0);
      const parts = [];
      if ((release && release > now) || tags.includes('preorder') || tags.includes('pre-order')) {
        state.preorder = true;
        const date = release > now ? el.dataset.releaseLabel : C.preorder.soon;
        parts.push(`<p class="rng-note rng-note--preorder">${esc(C.preorder.msg).replace('[date]', `<strong>${esc(date)}</strong>`)}</p>`);
      }
      let limit = Number(el.dataset.limit || 0);
      if (!limit) { const t = tags.find((x) => /^limit-\d+$/.test(x)); if (t) limit = Number(t.split('-')[1]); }
      if (limit) parts.push(`<p class="rng-note rng-note--limit">${esc(C.limit.msg).replace('[limit]', `<strong>${limit}</strong>`)}</p>`);
      el.innerHTML = parts.join('');
      el.hidden = !parts.length;
    });

    if (!C.countdown.enabled) return;
    $$('[data-rng-pcountdown]').forEach((el) => {
      let end = Number(el.dataset.end || 0);
      if (!end && C.countdown.tag && C.countdown.end && tagsOf(el).includes(C.countdown.tag)) end = C.countdown.end;
      if (!end || end <= Date.now() / 1000) return;
      el.innerHTML = `<p class="rng-pcd__label">${esc(C.countdown.msg)}</p><div data-box></div>`;
      el.hidden = false;
      mountTimer(el.querySelector('[data-box]'), end, () => { el.hidden = true; });
    });
  }

  /* ---------- stock bar ---------- */
  function initStock() {
    const els = $$('[data-rng-stock]');
    if (!els.length || !P || !C.stock.enabled) return;
    const upd = (v) => els.forEach((el) => {
      const q = v ? v.qty : 0;
      const show = v && v.managed && v.available && q > 0 && q <= C.stock.threshold;
      el.hidden = !show;
      if (!show) return;
      const pct = Math.max(6, Math.min(100, (q / C.stock.threshold) * 100));
      el.innerHTML = `<p class="rng-stock__msg">${esc(C.stock.msg).replace('[count]', `<strong>${q}</strong>`)}</p><div class="rng-stock__track"><span style="width:${pct}%"></span></div>`;
    });
    onVariant(upd);
    upd(currentVariant());
  }

  /* ---------- delivery estimate ---------- */
  function addBiz(date, n, skip) {
    const d = new Date(date);
    let added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); if (!skip || (d.getDay() !== 0 && d.getDay() !== 6)) added++; }
    return d;
  }
  function initDelivery() {
    const els = $$('[data-rng-delivery]');
    const D = C.delivery;
    if (!els.length || !D.enabled) return;
    if (state.preorder) { els.forEach((e) => { e.hidden = true; }); return; }
    const draw = () => {
      let parts;
      try {
        parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: D.tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false })
          .formatToParts(new Date()).map((p) => [p.type, p.value]));
      } catch (e) { const n = new Date(); parts = { year: n.getFullYear(), month: n.getMonth() + 1, day: n.getDate(), hour: n.getHours() }; }
      const hour = Number(parts.hour) % 24;
      const today = new Date(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
      const isBiz = (d) => !D.skipWeekends || (d.getDay() !== 0 && d.getDay() !== 6);
      let start = new Date(today);
      if (!(isBiz(today) && hour < D.cutoff)) { do { start.setDate(start.getDate() + 1); } while (!isBiz(start)); }
      const ship = D.processing > 0 ? addBiz(start, D.processing, D.skipWeekends) : start;
      const a = addBiz(ship, D.min, D.skipWeekends);
      const b = addBiz(ship, Math.max(D.max, D.min), D.skipWeekends);
      const f = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      const html = esc(D.msg).replace('[start]', `<strong>${f(a)}</strong>`).replace('[end]', `<strong>${f(b)}</strong>`);
      els.forEach((el) => { el.innerHTML = truck + `<span>${html}</span>`; el.hidden = false; });
    };
    draw();
    setInterval(draw, 600000);
  }

  /* ---------- trust badges ---------- */
  function initTrust() {
    $$('[data-rng-trust]').forEach((el) => {
      if (!C.trust.enabled) return;
      const list = el.querySelector('[data-rng-trust-list]');
      const items = C.trust.items.filter(Boolean);
      if (list) list.innerHTML = items.map((t) => `<li><svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M8 13.6 4.4 10 3 11.4l5 5 9-9L15.6 6z"/></svg>${esc(t)}</li>`).join('');
      const pay = el.querySelector('.rng-trust__pay');
      if (pay && !C.trust.pay) pay.hidden = true;
      el.hidden = !items.length && !C.trust.pay;
    });
  }

  /* ---------- frequently bought together ---------- */
  async function initFBT() {
    const el = $('[data-rng-fbt]');
    if (!el || !P || !C.fbt.enabled) return;
    const list = (await recs(P.id, C.fbt.count + 4))
      .filter((p) => p.id !== P.id && p.variants.some((v) => v.available))
      .slice(0, C.fbt.count);
    if (!list.length) return;
    const items = [{ main: true, title: P.title, url: P.url, image: P.image, variant: currentVariant() }]
      .concat(list.map((p) => ({ title: p.title, url: p.url, image: sized(p.featured_image, 200), variant: p.variants.find((v) => v.available) })));
    const draw = () => {
      el.innerHTML = `<h3 class="rng-fbt__title h4">${esc(C.fbt.heading)}</h3>
        <div class="rng-fbt__imgs">${items.map((it, i) => `${i ? '<span class="rng-fbt__plus" aria-hidden="true">+</span>' : ''}<a href="${esc(it.url)}">${it.image ? `<img src="${esc(it.image)}" alt="${esc(it.title)}" width="88" height="88" loading="lazy">` : ''}</a>`).join('')}</div>
        <ul class="rng-fbt__list">${items.map((it, i) => `<li><label><input type="checkbox" data-i="${i}" ${it.variant && it.variant.available ? 'checked' : 'disabled'}><span class="rng-fbt__name">${it.main ? `<em>${esc(C.fbt.thisItem)}</em> ` : ''}${esc(it.title)}</span><span class="rng-fbt__price">${it.variant ? money(it.variant.price) : ''}</span></label></li>`).join('')}</ul>
        <div class="rng-fbt__foot"><span>${esc(C.fbt.total)} <strong data-total></strong></span><button type="button" class="button rng-fbt__btn">${esc(C.fbt.button)}</button></div>`;
      total();
    };
    const checked = () => $$('input[data-i]:checked', el).map((c) => items[Number(c.dataset.i)]).filter((it) => it.variant && it.variant.available);
    const total = () => {
      const sel = checked();
      el.querySelector('[data-total]').textContent = money(sel.reduce((s, it) => s + it.variant.price, 0));
      el.querySelector('.rng-fbt__btn').disabled = !sel.length;
    };
    el.addEventListener('change', (e) => { if (e.target.matches('input[data-i]')) total(); });
    el.addEventListener('click', async (e) => {
      const btn = e.target.closest('.rng-fbt__btn');
      if (!btn) return;
      btn.disabled = true;
      const label = btn.textContent;
      btn.textContent = '…';
      try { await addItems(checked().map((it) => ({ id: it.variant.id, quantity: 1 }))); }
      catch (err) { alert(err.message); }
      btn.textContent = label;
      btn.disabled = false;
    });
    onVariant((v) => { items[0].variant = v; draw(); });
    draw();
    el.hidden = false;
  }

  /* ---------- description tabs ---------- */
  function initTabs() {
    if (!C.tabs) return;
    $$('.product__description').forEach((desc) => {
      if (desc.dataset.rngTabs) return;
      const heads = $$(':scope > h2, :scope > h3, :scope > h4, :scope > h5, :scope > h6', desc);
      if (!heads.length) return;
      const hasContent = (nodes) => nodes.some((n) => (n.textContent || '').trim() || n.nodeName === 'IMG' || (n.querySelector && n.querySelector('img,iframe,video,table')));
      const panels = [];
      let cur = { title: C.labels.description, nodes: [] };
      Array.from(desc.childNodes).forEach((n) => {
        if (heads.includes(n)) { if (hasContent(cur.nodes)) panels.push(cur); cur = { title: n.textContent.trim(), nodes: [] }; }
        else cur.nodes.push(n);
      });
      if (hasContent(cur.nodes)) panels.push(cur);
      if (panels.length < 2) return;
      const uid = 'rngtab' + Math.random().toString(36).slice(2, 7);
      const wrap = document.createElement('div');
      wrap.className = 'rng-tabs';
      const nav = document.createElement('div');
      nav.className = 'rng-tabs__nav';
      nav.setAttribute('role', 'tablist');
      wrap.appendChild(nav);
      const select = (i) => panels.forEach((p, j) => { p.pane.hidden = i !== j; p.btn.setAttribute('aria-selected', String(i === j)); p.btn.tabIndex = i === j ? 0 : -1; });
      panels.forEach((p, i) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'rng-tabs__btn'; b.id = `${uid}-t${i}`;
        b.setAttribute('role', 'tab'); b.setAttribute('aria-controls', `${uid}-p${i}`);
        b.textContent = p.title;
        b.addEventListener('click', () => select(i));
        b.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const n = (i + (e.key === 'ArrowRight' ? 1 : panels.length - 1)) % panels.length;
          select(n); panels[n].btn.focus();
        });
        nav.appendChild(b);
        const pane = document.createElement('div');
        pane.className = 'rng-tabs__panel'; pane.id = `${uid}-p${i}`;
        pane.setAttribute('role', 'tabpanel'); pane.setAttribute('aria-labelledby', b.id);
        p.nodes.forEach((n) => pane.appendChild(n));
        wrap.appendChild(pane);
        p.btn = b; p.pane = pane;
      });
      desc.innerHTML = '';
      desc.appendChild(wrap);
      desc.dataset.rngTabs = '1';
      select(0);
    });
  }

  /* ---------- sticky add to cart ---------- */
  function initSticky() {
    if (!C.sticky || !P) return;
    const getBtn = () => $('product-info .product-form__submit') || $('.product-form__submit');
    if (!getBtn()) return;
    const bar = document.createElement('div');
    bar.className = 'rng-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = `<div class="rng-sticky__inner page-width">${P.image ? `<img src="${esc(P.image)}" alt="" width="48" height="48">` : ''}<div class="rng-sticky__info"><span class="rng-sticky__title">${esc(P.title)}</span><span class="rng-sticky__price" data-price></span></div><button type="button" class="button rng-sticky__btn" data-btn tabindex="-1"></button></div>`;
    document.body.appendChild(bar);
    const btnEl = bar.querySelector('[data-btn]');
    const sync = () => {
      const main = getBtn();
      const v = currentVariant();
      bar.querySelector('[data-price]').textContent = v ? money(v.price) : '';
      if (main) {
        btnEl.textContent = (main.querySelector('span') || main).textContent.trim();
        btnEl.disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
      }
    };
    btnEl.addEventListener('click', () => {
      const main = getBtn();
      if (main && !main.disabled) main.click();
      else if (main) main.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        const main = getBtn();
        const show = !!main && main.getBoundingClientRect().bottom < 0;
        if (show) sync();
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', String(!show));
        btnEl.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('rng-sticky-on', show);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onVariant(sync);
    sync();
  }

  /* ---------- infinite scroll ---------- */
  function initInfinite() {
    if (!C.infinite) return;
    const grid = document.getElementById('product-grid');
    const pag = $('.pagination-wrapper');
    if (!grid || !pag || pag.dataset.rngInf) return;
    pag.dataset.rngInf = '1';
    const cur = Number(pag.dataset.page || new URL(window.location.href).searchParams.get('page') || 1);
    const next = $$('a[href]', pag).map((a) => new URL(a.href, window.location.origin)).find((u) => Number(u.searchParams.get('page')) === cur + 1);
    if (!next) return;
    const io = new IntersectionObserver(async (entries) => {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      pag.classList.add('rng-loading');
      try {
        const html = await (await origFetch(next.toString())).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = $$('#product-grid > *', doc);
        newItems.forEach((n) => {
          [n].concat($$('.scroll-trigger', n)).forEach((x) => x.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in'));
          grid.appendChild(document.adoptNode(n));
        });
        const newPag = $('.pagination-wrapper', doc);
        if (newPag) {
          const imported = document.adoptNode(newPag);
          imported.dataset.page = String(cur + 1);
          pag.replaceWith(imported);
          initInfinite();
        } else pag.remove();
      } catch (e) { pag.classList.remove('rng-loading'); }
    }, { rootMargin: '800px 0px' });
    io.observe(pag);
  }

  /* ---------- "fresh in the shop" toasts ---------- */
  function initActivity() {
    const A = C.activity;
    if (!A.enabled || !A.items.length || store.get('rng-act-off', true)) return;
    const items = A.items.slice().sort(() => Math.random() - 0.5);
    let i = 0, timer;
    const el = document.createElement('div');
    el.className = 'rng-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
    const show = () => {
      const it = items[i++ % items.length];
      el.innerHTML = `<a class="rng-toast__link" href="${esc(it.url)}">${it.image ? `<img src="${esc(it.image)}" alt="" width="56" height="56" loading="lazy">` : ''}<span><small>${esc(A.label)}</small><strong>${esc(it.title)}</strong><span>${esc(it.price)}</span></span></a><button type="button" class="rng-toast__x" aria-label="Close">&times;</button>`;
      el.classList.add('is-on');
      setTimeout(() => el.classList.remove('is-on'), 6500);
    };
    el.addEventListener('click', (e) => {
      if (!e.target.closest('.rng-toast__x')) return;
      el.classList.remove('is-on');
      clearInterval(timer);
      store.set('rng-act-off', '1', true);
    });
    setTimeout(() => { show(); timer = setInterval(show, A.interval * 1000); }, A.delay * 1000);
  }

  /* ---------- newsletter popup ---------- */
  function initNewsletter() {
    const np = document.getElementById('rng-np');
    if (!np) return;
    let lastFocus = null;
    const open = () => { lastFocus = document.activeElement; np.hidden = false; requestAnimationFrame(() => np.classList.add('is-on')); const f = np.querySelector('input[type=email], .rng-np__x'); if (f) f.focus(); };
    const close = () => { np.classList.remove('is-on'); setTimeout(() => { np.hidden = true; }, 250); store.set('rng-np', String(Date.now())); if (lastFocus) lastFocus.focus(); };
    np.addEventListener('click', (e) => { if (e.target === np || e.target.closest('[data-rng-close]')) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !np.hidden) close(); });
    if (np.querySelector('[data-rng-np-success]') || np.querySelector('.rng-np__err')) { open(); store.set('rng-np', String(Date.now())); return; }
    if (Date.now() - Number(store.get('rng-np') || 0) < C.np.days * 86400000) return;
    if (window.Shopify && Shopify.designMode) return;
    setTimeout(open, C.np.delay * 1000);
  }

  /* ---------- cookie consent ---------- */
  function initCookie() {
    if (!C.cookie.enabled) return;
    const done = !!store.get('rng-cookie');
    const build = (api) => {
      const bar = document.createElement('div');
      bar.className = 'rng-cookie';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Cookie consent');
      bar.innerHTML = `<p>${esc(C.cookie.text)} ${C.cookie.link ? `<a href="${esc(C.cookie.link)}">${esc(C.cookie.linkLabel)}</a>` : ''}</p><div class="rng-cookie__btns"><button type="button" class="button button--secondary" data-v="no">${esc(C.cookie.decline)}</button><button type="button" class="button" data-v="yes">${esc(C.cookie.accept)}</button></div>`;
      bar.addEventListener('click', (e) => {
        const b = e.target.closest('[data-v]');
        if (!b) return;
        const ok = b.dataset.v === 'yes';
        store.set('rng-cookie', b.dataset.v);
        if (api && api.setTrackingConsent) { try { api.setTrackingConsent({ analytics: ok, marketing: ok, preferences: ok, sale_of_data: ok }, () => {}); } catch (err) {} }
        bar.remove();
      });
      document.body.appendChild(bar);
    };
    if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
        const api = !err && window.Shopify.customerPrivacy;
        if (api && typeof api.shouldShowBanner === 'function') { if (api.shouldShowBanner() && !done) build(api); }
        else if (!done) build(api || null);
      });
    } else if (!done) build(null);
  }

  /* ---------- "-25%" sale badges on product cards ---------- */
  function salePercent() {
    const num = (el) => (el ? parseFloat(el.textContent.replace(/[^0-9.,]/g, '').replace(/,(?=\d{3}\b)/g, '').replace(',', '.')) : NaN);
    $$('.card-wrapper, .product-card-wrapper').forEach((card) => {
      if (card.dataset.rngPct) return;
      card.dataset.rngPct = '1';
      const price = card.querySelector('.price--on-sale');
      const badge = card.querySelector('.card__badge .badge');
      if (!price || !badge) return;
      const sale = num(price.querySelector('.price-item--sale'));
      const reg = num(price.querySelector('.price__sale s .price-item--regular, s.price-item--regular, .price-item--regular'));
      if (!(sale > 0 && reg > sale)) return;
      const pct = Math.round((1 - sale / reg) * 100);
      if (pct >= 1) { badge.textContent = `Sale -${pct}%`; badge.classList.add('rng-pct'); }
    });
  }

  /* ---------- small sales increasers ---------- */
  function initExtras() {
    if (C.backTop) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'rng-top';
      b.setAttribute('aria-label', C.labels.top);
      b.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M12 5 4 13l1.4 1.4L11 8.8V20h2V8.8l5.6 5.6L20 13z"/></svg>';
      b.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
      document.body.appendChild(b);
      window.addEventListener('scroll', () => b.classList.toggle('is-on', window.scrollY > 900), { passive: true });
    }
    if (C.tabAway) {
      const original = document.title;
      document.addEventListener('visibilitychange', () => { document.title = document.hidden ? C.tabAway : original; });
    }
    if (C.protect) {
      document.documentElement.classList.add('rng-protect');
      document.addEventListener('contextmenu', (e) => { if (e.target.closest('img, picture, video')) e.preventDefault(); });
      document.addEventListener('dragstart', (e) => { if (e.target.tagName === 'IMG') e.preventDefault(); });
    }
    if (C.geo && C.country) {
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, { acceptNode: (n) => (n.nodeValue.indexOf('%country%') > -1 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP) });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((n) => { n.nodeValue = n.nodeValue.split('%country%').join(C.country); });
    }
    if (C.salePct) salePercent();
    $$('[data-rng-days]').forEach((el) => {
      const t = Number(el.dataset.rngDays || 0);
      if (!t) return;
      const days = Math.ceil((t - Date.now() / 1000) / 86400);
      el.textContent = days > 1 ? `In ${days} days` : days === 1 ? 'Tomorrow' : days === 0 ? 'Today' : 'Out now';
      el.hidden = false;
    });
  }

  /* ---------- boot ---------- */
  function start() {
    initExtras();
    initCountdownSections();
    initNotices();
    initStock();
    initDelivery();
    initTrust();
    initTabs();
    initSticky();
    initFBT();
    initInfinite();
    initActivity();
    initNewsletter();
    initCookie();
    refreshCart();

    document.addEventListener('change', () => setTimeout(checkVariant, 350));
    if (hasPubSub()) {
      if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(checkVariant, 60));
      if (PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
    }
    lastVid = (currentVariant() || {}).id || null;

    let moT;
    new MutationObserver(() => {
      clearTimeout(moT);
      moT = setTimeout(() => { renderCartUI(); initInfinite(); initTabs(); if (C.salePct) salePercent(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
